import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent {
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() mode: 'determinate' | 'indeterminate' = 'indeterminate';
  @Input() value = 0;

  @HostBinding('class')
  get classes(): string {
    const classList: string[] = ['progress-bar'];

    if (this.color) {
      classList.push(`progress-bar--${this.color}`);
    }

    if (this.mode === 'indeterminate') {
      classList.push('progress-bar--indeterminate');
    } else {
      classList.push('progress-bar--determinate');
    }

    return classList.join(' ');
  }

  get progressValue(): number {
    if (this.mode === 'indeterminate') {
      return 0;
    }
    return Math.max(0, Math.min(100, this.value));
  }
}
